import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';

import {clearBookingNotificationToast} from '../../../redux/actions/Booking/Notification/bookingNotificationActions';
import {NETWORK_RESERVATION_DETAIL_SHORT, NETWORK_RESERVATIONS} from '../../../constants/appUrls.constants';
import {formatAmount, formatShortDate} from './bookingNotificationHelpers';

const SlideLeft = (props) => <Slide {...props} direction="left" />;

/**
 * Yeni rezervasyon toast'i.
 *
 * Cift-tetikleme korumasi reducer'da: toast yalnizca `latest_id > toastedId`
 * iken uretilir, ayni yigin yeniden yoklandiginda tekrar cikmaz.
 */
export default function BookingNotificationToast() {

    const {t, i18n} = useTranslation();
    const dispatch = useDispatch();
    const toast = useSelector(props => props.bookingNotificationReducer.toast);

    const close = () => dispatch(clearBookingNotificationToast());

    const booking = toast ? toast.item : null;
    const count = toast ? toast.count : 0;

    const guestName = booking && booking.guest ? booking.guest.full_name : null;
    const amount = booking ? formatAmount(booking.total, i18n.language) : null;
    const checkin = booking ? formatShortDate(booking.checkin_date) : null;

    const title = count > 1
        ? t('enw-booking_notification-toast_many', {
            defaultValue: '{{total}} yeni rezervasyon',
            total: count,
        })
        : t('enw-booking_notification-toast_one', 'Yeni rezervasyon');

    // Tek kayit varsa dogrudan detayina, coksa listeye goturur.
    const targetUrl = count === 1 && booking
        ? NETWORK_RESERVATION_DETAIL_SHORT + booking.id
        : NETWORK_RESERVATIONS;

    return (
        <Snackbar
            open={!!toast}
            onClose={(event, reason) => {
                if (reason === 'clickaway') return;
                close();
            }}
            autoHideDuration={8000}
            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
            TransitionComponent={SlideLeft}
            classes={{root: 'bkn-toast__root'}}
        >
            <div className="bkn-toast" role="alert">
                <span className="bkn-toast__icon">
                    <i className="fas fa-bell" />
                </span>

                <div className="bkn-toast__body">
                    <p className="bkn-toast__title">{title}</p>
                    {
                        booking &&
                        <p className="bkn-toast__desc">
                            {guestName || t('enw-booking_notification-guest_unknown', 'Misafir adı belirtilmemiş')}
                        </p>
                    }
                    {
                        booking && (amount || checkin) &&
                        <p className="bkn-toast__meta">
                            {amount && <span className="bkn-toast__amount">{amount} {booking.currency_code}</span>}
                            {amount && checkin && <span className="bkn-toast__dot">·</span>}
                            {checkin && <span>{checkin}</span>}
                        </p>
                    }
                    <Link to={targetUrl} className="bkn-toast__action" onClick={close}>
                        {
                            count === 1
                                ? t('enw-booking_notification-toast_view', 'Rezervasyonu gör')
                                : t('enw-booking_notification-see_all', 'Tüm rezervasyonları gör')
                        }
                        <i className="fas fa-arrow-right" />
                    </Link>
                </div>

                <button
                    type="button"
                    className="bkn-toast__close"
                    onClick={close}
                    aria-label={t('btn-close')}
                >
                    <i className="fal fa-times" />
                </button>
            </div>
        </Snackbar>
    );
}
